import { createFileRoute } from '@tanstack/react-router';

import { SomePlayerProfilePageWidget } from '@features/user/pages/SomePlayerProfilePage/SomePlayerProfilePageWidget';

export const Route = createFileRoute('/profile/$userId/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { userId } = Route.useParams();
  return <SomePlayerProfilePageWidget userId={userId} />;
}
